import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { DefectService } from '../../services/defect.service';

// Leeres Label blendet die Krume aus; sonst stünde „Abweichung › Abweichung“, weil die Übersicht gleich heißt.
const LABEL_WITHOUT_KEY = '';

export const defectKeyBreadcrumbResolver: ResolveFn<string> = (route) => {
  const projectId = route.pathFromRoot.map((r) => r.paramMap.get('projectId')).find(Boolean) ?? '';
  const defectId = route.paramMap.get('defectId') ?? '';
  return inject(DefectService)
    .get(projectId, defectId)
    .pipe(
      map((defect) => defect.key || LABEL_WITHOUT_KEY),
      catchError(() => of(LABEL_WITHOUT_KEY)),
    );
};
